import { FunctionalComponent, h } from 'preact';

export interface LinkProps {
	href: string;
	text: string;
	type: 'internal' | 'external';
}
interface ServiceCardLinkProps extends LinkProps {
	highlighted?: boolean;
}
export const ServiceCardLinkMobile: FunctionalComponent<ServiceCardLinkProps> = (props) => {
	const { href, text, type, highlighted } = props;
	return (
		<a href={href} className={`SP-Link SP-Iconized--left SP-ServiceCardMobile__more`} target={type === 'external' ? '_blank' : undefined}>
			<svg
				className={`SPi SP-Iconized__icon SP-Link__icon ${type === 'internal' ? 'SPi-link' : 'SPi-linkNewWindow'}`}
				aria-hidden="true"
				focusable="false"
			>
				<use href={`#SPi-${type === 'internal' ? 'link' : 'linkNewWindow'}`} />
			</svg>
			<span class="SP-Link__text SP-Iconized__text">
				<span className="SP-Link__title">{text}</span>
			</span>
		</a>
	);
};
